module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/gre/sections/apps/assets/prep_app-65c855440fe6875d7d70aa8028e3c9f4.png";